import type { FocusEvent } from 'react'

export interface TimePickerProps {
  fieldName: string
  value?: string
  error: boolean
  handleChange: (time?: string) => void
  handleBlur: (e: FocusEvent<HTMLInputElement, Element>) => void
  disabled?: boolean
  handleFieldClear?: VoidFunction
  withinPopup?: boolean
  inputPlaceholder?: string
  'data-testid'?: string
}
